import React from 'react';

import styles from './SettingsPage.module.css';

type Props = {
  text: string;
};

export const SettingsPageTitle = ({ text }: Props) => {
  return <div className={styles.SettingsPage__Title}>{text}</div>;
};
